import React from 'react';
import { ShoppingBag } from 'lucide-react';
export function MerchHero() {
  return <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-20" data-id="element-567">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-568">
        <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-6" data-id="element-569">
          <ShoppingBag className="h-6 w-6 text-[#dc2626]" data-id="element-570" />
        </div>

        <p className="text-[#dc2626] font-bold text-sm uppercase tracking-wider mb-4" data-id="element-571">
          OFFICIAL GEAR
        </p>

        <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-572">
          Che Ko Merch Store
        </h1>

        <div className="h-1 w-16 bg-[#dc2626] mx-auto" data-id="element-573"></div>
      </div>
    </section>;
}